import { makeStyles } from '@mui/styles'
import Colors from 'utils/Colors'

export default makeStyles((theme) => ({
  dataTable: {
    borderCollapse: 'collapse',
    backgroundColor: '#FFFFFF',
    boxShadow:
      '0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12)',
    borderRadius: '5px 5px 0 0',
    width: '100%',
    minWidth: '1366px',

    '& thead tr:first-child': {
      '& th:first-child': {
        borderRadius: '4px 0 0 0',
      },
      '& th:last-child': {
        borderRadius: '0 4px 0 0',
      },
    },

    '& thead tr': {
      backgroundColor: theme.palette.grey[800],
      color: '#FFFFFF',
      textTransform: 'uppercase',

      '& th': {
        padding: '5px 5px',
        textAlign: 'center',
        fontSize: '0.8rem',
        width: 120,
      },

      '& middle-col': {
        whiteSpace: 'break-spaces',
        minWidth: 50,
        maxWidth: 52,
      },
    },

    '& tbody tr': {
      borderBottom: '1px solid rgba(224, 224, 224, 1)',

      '&:nth-child(even)': {
        backgroundColor: '#EFEFEF',
      },

      '&:hover': {
        backgroundColor: 'rgba(0, 0, 0, 0.15)',
      },

      '& td': {
        padding: '0.4rem 0.3rem',
        fontSize: '1.2rem',
        textAlign: 'center',
        '@media only screen and (max-width : 1800px)': {
          fontSize: '1.1rem',
        },
        '@media only screen and (max-width : 1700px)': {
          fontSize: '1.0rem',
        },
        '@media only screen and (max-width : 1570px)': {
          fontSize: '0.9rem',
        },
      },

      '& td:nth-child(-n+5)': {
        width: 300,
      },
    },

    '& tfoot tr': {
      '& td': {
        padding: 10,
      },
    },
  },

  iconContent: {
    maxWidth: 80,
    minWidth: 65,
  },

  detailsContent: {
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },

  emptyTable: {
    fontSize: 12,
    fontWeight: 'bold',
    textAlign: 'center',
    '&:hover': {
      backgroundColor: Colors.white,
    },
  },

  score: {
    fontWeight: '900',
    fontSize: 12,
    color: '#222222',
    alignSelf: 'center',
    padding: '5px',
    borderRadius: 5,
    width: 'fit-content',
    margin: '0 auto',
  },

  scoreHeaders: {
    backgroundColor: theme.palette.grey[400],
    color: '#212121',
  },

  scoreRelatedHeader: {
    backgroundColor: theme.palette.grey[600],
    color: '#FFFFFF',
    borderRight: '1px solid #FFF',
  },

  bgcHeaders: {
    backgroundColor: theme.palette.grey[400],
    color: '#212121',
  },

  bgcRelatedHeader: {
    backgroundColor: theme.palette.grey[600],
    color: '#FFFFFF',
  },

  iconButton: {
    padding: 5,
  },

  tooltipText: {
    fontSize: 12,
  },

  noMaxWidth: {
    maxWidth: 'none',
  },

  cursorPointer: {
    cursor: 'pointer',
  },

  statusTooltip: {
    fontSize: 12,
    '.MuiTooltip-popper': {
      transform: 'rotate(-90deg)',
    },
  },

  modal: {
    display: 'flex',
    backgroundColor: '#FFFFFF',
    minHeight: 150,
    borderRadius: '10px',
    width: '90vw',
    height: '90vh',
    padding: '50px 40px 20px 40px',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    outline: 'none',
    fontSize: 14,
  },

  defaultCursor: {
    cursor: 'default',
  },

  bgc: {
    padding: 10,
  },

  errorCaptured: {
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    padding: 5,
  },

  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.25rem',
    padding: '0 1rem',
    width: '100%',

    '& p.name': {
      textTransform: 'capitalize',
    },

    '& > p > span': {
      fontWeight: 600,
    },
  },

  // content: {
  //   // padding: 10,
  //   overflowY: 'auto',
  //   overflowX: 'hidden',
  //   marginBottom: 20,
  // },

  section: {
    marginTop: 10,
    marginBottom: 20,
  },

  firstSection: {
    marginTop: 45,
    marginBottom: 20,
  },

  fixedHeader: {
    position: 'fixed',
    paddingTop: '1rem',
    marginBottom: '1rem',
    paddingLeft: '0.65rem',
    top: 70,
    left: 45,
    right: 59,
    backgroundColor: 'white',
    zIndex: 1,
  },

  headerButtonRow: {
    display: 'flex',
    gap: '1rem',
    marginBottom: 8,
    alignItems: 'center',
    alignSelf: 'center',
    justifyContent: 'space-between',
  },

  leftHeaderButtonRow: {
    display: 'flex',
    gap: '1.5rem',
    alignItems: 'center',
  },
}))
